module.exports = __webpack_public_path__ + "static/media/branding-second@3x.79bbb9b1.jpg";